import DOMPurify from 'dompurify';

type Props = {
  html: string;
};

export default function MarkupPreview({ html }: Props) {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(html, {
          ADD_ATTR: ['target'],
        }),
      }}
    />
  );
}
